// We want to use an 'a' tag when not linking to another page within
// the current React app. This includes:
// - truly external links (github.com)
// - Aurora (cloud.digitalocean.com)
// - links to different anchor IDs ('#introduction')
export const shouldUseAnchor = (to: string): boolean => !!(to.match(/^https?:\/\//i) || to.match(/^#/));
